import { render } from "./DoctorOverview.vue?vue&type=template&id=60039ce6&scoped=true&ts=true"
import script from "./DoctorOverview.vue?vue&type=script&lang=ts"
export * from "./DoctorOverview.vue?vue&type=script&lang=ts"

import "./DoctorOverview.vue?vue&type=style&index=0&id=60039ce6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60039ce6"]])

export default __exports__